/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ActivityType = "activated" | "completedCourse" | "failedCourse" | "newCourse" | "submittedCourseTOS" | "%future added value";
export type ActivityFeedCard_company = {
    readonly activity: {
        readonly edges: ReadonlyArray<{
            readonly type: ActivityType;
            readonly " $fragmentRefs": FragmentRefs<"UserUpdate_activity">;
        } | null> | null;
    };
    readonly " $refType": "ActivityFeedCard_company";
};
export type ActivityFeedCard_company$data = ActivityFeedCard_company;
export type ActivityFeedCard_company$key = {
    readonly " $data"?: ActivityFeedCard_company$data;
    readonly " $fragmentRefs": FragmentRefs<"ActivityFeedCard_company">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ActivityFeedCard_company",
    "type": "Company",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "activity",
            "storageKey": "activity(page:{\"limit\":80})",
            "args": [
                {
                    "kind": "Literal",
                    "name": "page",
                    "value": {
                        "limit": 80
                    }
                }
            ],
            "concreteType": "ActivityPage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Activity",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "type",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "UserUpdate_activity",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '5d7c8907f43935f7d48c557dab22923b';
export default node;
